





































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { ActShortList as IActList } from "@/api/models/act-short-list";
import { ActShort as IAct } from "@/api/models/act-short";
import acts, { ActListParams } from "@/getinfo-api/acts";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { Employee as IEmployee } from "@/api/models/employee";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { AxiosError } from "axios";
import ActItemPreview from "@/components/act/ActItemPreview.vue";
import SelectEntity from "@/components/form/SelectEntity.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { SortFields, ActSort } from "@/plugins/sort-fields";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";

@Component({
  components: {
    CSingleSelect,
    CField,
    CPage,
    ActItemPreview,
    SelectEntity,
    CustomDatepicker
  }
})
export default class ActList extends Vue {
  acts: Array<IAct> = [];
  number: string | undefined;
  responsibleId!: string | undefined;
  signedAtMin!: Date | undefined;
  signedAtMax!: Date | undefined;
  formedAtMin!: Date | undefined;
  formedAtMax!: Date | undefined;
  amountMin!: number | undefined;
  amountMax!: number | undefined;
  employeesList!: Array<IEmployee> | undefined;
  contractorId!: string | undefined;
  contractorType!: "juridical" | "physical" | undefined;
  actsCount: number = 0;
  showSpinner: boolean = false;
  limit: number = 30;
  offset: number = 0;
  isSignedAt!: boolean | undefined;
  documentsManager!: EmployeesListClass;
  sorted: SortFields<ActSort> = new SortFields(ActSort.formedAt);
  contractorList: ContractorsListClass = new ContractorsListClass({
    companyId: this.company.id
  });

  data() {
    return {
      isSignedAt: undefined,
      number: undefined,
      responsibleId: undefined,
      signedAtMin: undefined,
      signedAtMax: undefined,
      formedAtMin: undefined,
      formedAtMax: undefined,
      amountMin: undefined,
      amountMax: undefined,
      employeesList: undefined,
      documentsManager: undefined,
      contractorId: undefined,
      contractorType: undefined
    };
  }

  get sortStatus() {
    return ActSort;
  }

  acceptSort(sort: ActSort) {
    this.sorted.changeSort(sort);
    this.applyFilter();
  }

  updateActsLists() {
    this.actsCount = 0;
    this.offset = 0;
    this.acts = [];
    this.getActs();
  }

  get company() {
    return this.$store.getters.selectedCompany;
  }

  showMore() {
    this.offset += this.limit;
    this.getActs(this.offset);
  }

  getEmployee() {
    let params: EmployeeListParams = {
      id: this.company.id,
      roles: ["document_manager"]
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.employeesList = res.data.employees;
    });

    this.documentsManager = new EmployeesListClass({
      id: this.company.id,
      roles: ["document_manager"]
    });
  }

  @Watch("company")
  applyFilter() {
    this.actsCount = 0;
    this.offset = 0;
    this.acts = [];
    this.employeesList = undefined;
    this.responsibleId = undefined;
    this.getActs();
    this.getEmployee();
  }

  clearForm() {
    this.offset = 0;
    this.acts = [];
    this.actsCount = 0;
    this.number = undefined;
    this.formedAtMin = undefined;
    this.formedAtMax = undefined;
    this.amountMin = undefined;
    this.amountMax = undefined;
    this.signedAtMin = undefined;
    this.signedAtMax = undefined;
    this.isSignedAt = undefined;
    this.responsibleId = undefined;
    this.contractorType = undefined;
    this.contractorId = undefined;
    this.getActs();
  }

  getActs(offset: number = 0) {
    this.showSpinner = true;
    let params: ActListParams = {
      number: this.number ? this.number : undefined,
      responsibleId: this.responsibleId ? this.responsibleId : undefined,
      companyId: this.company.id,
      priceMin: this.amountMin
        ? this.$converter.setPrice(this.amountMin)
        : undefined,
      priceMax: this.amountMax
        ? this.$converter.setPrice(this.amountMax)
        : undefined,
      signedAtMin: this.signedAtMin ? this.signedAtMin : undefined,
      signedAtMax: this.signedAtMax ? this.signedAtMax : undefined,
      formedAtMin: this.formedAtMin ? this.formedAtMin : undefined,
      formedAtMax: this.formedAtMax ? this.formedAtMax : undefined,
      isSignedAt: this.isSignedAt,
      contractorType: this.contractorType,
      contractorId: this.contractorId,
      sort: this.sorted.sort,
      order: this.sorted.order,
      limit: this.limit,
      offset: offset
    };

    acts(params)
      .then((res: { data: IActList }) => {
        this.actsCount = res.data?.count;
        res.data?.items?.forEach((element: IAct) => {
          this.acts.push(element);
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  @Watch("contractorType")
  checkClientType() {
    this.contractorList.params.type = this.contractorType
      ? this.contractorType
      : undefined;
    this.contractorList.params.offset = 0;
    this.contractorList.listItems = [];
    this.contractorList.list();
  }

  mounted() {
    if (this.company.id) {
      this.getActs();
      this.getEmployee();
    }
  }
}
